import SignUpContext from '@activities/auth/SignUpActivity/context/SignUpContext';
import { ReactNode, useState } from 'react';

interface Props {
    children?: ReactNode;
    kakaoId?: number;
    nickname?: string;
    appleId?: string;
}

function SignUpContextProvider({
  children, kakaoId, nickname, appleId,
}:Props) {
  const useVerified = useState<boolean>(false);
  const usePhoneNo = useState<string>('');
  const useMarketing = useState<boolean>(false);
  const useLocation = useState<boolean>(false);
  const useInputPhoneNo = useState<string>('');
  const useInputSmsAuthCode = useState<string>('');
  const useSelectedTermCategories = useState<string[]>([]);
  return (
      <SignUpContext value={{
        useVerified,
        usePhoneNo,
        useMarketing,
        useLocation,
        useInputPhoneNo,
        useInputSmsAuthCode,
        useSelectedTermCategories,
        kakaoId,
        nickname,
        appleId,
      }}>
          {children}
      </SignUpContext>
  );
}

export default SignUpContextProvider;
